
import {  AlertService } from './toast/alert.service';
import { CustomLoadingComponent } from './custom-loading/custom-loading.component';
import {  AlertComponent } from './toast/alert.component';

import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyCustomMaskPipe } from './pipes/my-custom-mask.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { FirstLetterCapitalPipe } from './pipes/first-letter-capital.pipe';
import { CharCountDirective } from './directive/char-count.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [CustomLoadingComponent,FirstLetterCapitalPipe,MyCustomMaskPipe,CharCountDirective],
  providers: [],
  exports: [CustomLoadingComponent,FirstLetterCapitalPipe,MyCustomMaskPipe,TranslateModule,CharCountDirective]

})

export class CommonUtilityModule {

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CommonUtilityModule,
      providers: [ ]
      
    };
  }

 }
